<template>
  <div>
    <div
      class="p-2 question text-logo pointer"
      @click="showAnswer = !showAnswer"
    >
      {{ question }}
      <i
        class="icon fa"
        :class="{ 'fa-plus': !showAnswer, 'fa-minus': showAnswer }"
      ></i>
    </div>
    <transition name="fade" mode="out-in">
      <div v-if="showAnswer" class="subtitle answer p-3">
        {{ answer || "Lorem ipsu." }}
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Question",
  props: ["question", "answer"],
  data() {
    return { showAnswer: false };
  },
};
</script>

<style lang="scss" scoped>
.question {
  border-radius: 5px;
  font-size: 18px;
  font-weight: bold;
  background: #f0eeee;
  box-shadow: 0 2px 7px 3px rgba(64, 64, 64, 0.1);
}

.answer {
  font-size: 18px;
}

.icon {
  float: right;
  margin-right: 10px;
  margin-top: 5px;
  color: var(--color-logo);
}
</style>
